<ng-select
  [items]="departmentChoices()"
  class="dropdown-user std-skin opened-search-icon custom custom-multi show-full-text"
  [class.is-invalid]="isInvalid"
  bindValue="value"
  [notFoundText]="'SELECT.No items found' | translate"
  [placeholder]="placeholder | translate"
  [loading]="loading()"
  [searchFn]="customSearchFn"
  [notFoundText]="'SELECT.No items found' | translate"
  [disabled]="isDisabled()"
  [ngModel]="selected()"
  (ngModelChange)="onSelectItem($event)"
>
  <ng-template ng-label-tmp let-item="item">
    @if (item.context) {
      <div class="item-filter" class="std-bubble p-0 border-0">
        <app-profile-display
          [person]="item.context"
          [defaultPhoto]="'assets/images/default-dept.png'"
        ></app-profile-display>
        <span class="text-truncate me-base-l8">
          {{
            item.context[
              lang() === 'en'
                ? 'display_with_code_en'
                : 'display_with_code'
            ] || '-'
          }}
        </span>
      </div>
    }
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <div class="d-flex" id="item-filter">
      <div class="col-auto d-flex align-items-center me-base-l6">
        <app-profile-display
          [person]="item.context"
          [defaultPhoto]="'assets/images/default-dept.png'"
        ></app-profile-display>
      </div>
      <div class="col w-0">
        <label class="d-block fw-medium text-truncate mb-1">
          {{
            item.context[
              lang() === 'en'
                ? 'display_with_code_en'
                : 'display_with_code'
            ] || '-'
          }}
        </label>
        <label
          class="d-block fs-base-l4 fw-normal text-truncate lh-sm mb-0"
        >
          ({{ item.context.member_count || '-' }}
          {{ 'COMMON.UNITS.People' | translate }})
        </label>
      </div>
    </div>
  </ng-template>
</ng-select>
